export default __webpack_public_path__ + "static/media/8826.ca404bd0.svg";